import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/play-btn.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-44f77a3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "question-detail aio-question-detail",
  "talqs-app": ""
}
const _hoisted_2 = { class: "m-que-section" }
const _hoisted_3 = { class: "m-title" }
const _hoisted_4 = {
  key: 0,
  class: "u-desc"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-full-width-seperator" }, null, -1))
const _hoisted_7 = { class: "m-que-section m-answer-section" }
const _hoisted_8 = {
  key: 0,
  class: "m-answer-detail"
}
const _hoisted_9 = { class: "m-answer-label" }
const _hoisted_10 = { class: "m-section-content m-answer-desc error" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "talqs_panel" }
const _hoisted_13 = {
  key: 0,
  class: "talqs_analyze_item_index"
}
const _hoisted_14 = { class: "talqs_panel_item" }
const _hoisted_15 = { class: "talqs_panel_item_content" }
const _hoisted_16 = { class: "m-answer-detail" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-answer-label" }, "正确答案", -1))
const _hoisted_18 = { class: "m-answer-desc success" }
const _hoisted_19 = ["id"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-full-width-seperator" }, null, -1))
const _hoisted_21 = { class: "m-que-section" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-section-title" }, "题目解析", -1))
const _hoisted_23 = ["id"]
const _hoisted_24 = {
  key: 0,
  class: "m-que-section"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-section-title" }, "视频讲解", -1))
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "video-btn"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "m-section-title u-top m-flex-section",
        style: _normalizeStyle({ paddingTop: $setup.isWeekStudy ? '0.25rem' : '18px' })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(`${$setup.queTypeDes}题`) + " ", 1),
          (!$setup.isWeekStudy)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "共" + _toDisplayString($setup.total) + "小题", 1))
            : _createCommentVNode("", true)
        ]),
        (!$setup.isWeekStudy && $setup.addedWrongStatusChecked && !$setup.addedWrong)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "m-add-wrong-btn join-wrong",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.addWrongList($setup.queId)))
            }, " 加入错题本 "))
          : _createCommentVNode("", true),
        (!$setup.isWeekStudy && $setup.addedWrongStatusChecked && $setup.addedWrong)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "m-add-wrong-btn cancel-wrong",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.cancelWrongList($setup.queId)))
            }, " 移出错题本 "))
          : _createCommentVNode("", true)
      ], 4),
      _createElementVNode("div", {
        class: "m-section-content question-title m-question-analysis-title",
        id: `questionAanlysisiTitle_${$props.questionIndex}`,
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.preventDefaultEvent && $setup.preventDefaultEvent(...args)), ["prevent"]))
      }, null, 8, _hoisted_5)
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["m-section-title", { error: !$setup.isRight, success: $setup.isRight }])
      }, _toDisplayString($setup.isRight ? '回答正确' : '回答错误'), 3),
      (!$setup.isRight)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.isWeekStudy ? '你的答案' : '回答错误'), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "talqs_answer clearfix",
                id: `myAnswer_${$props.questionIndex}`
              }, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.myAnswer, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `myanswer-${$props.questionIndex}-${index}`
                    }, [
                      ($setup.myAnswer.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(index + 1), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(item?.length
                        ? /(\$\$*\$)/.test(item.join(' ; ')) || /(\$*\$)/.test(item.join(' ; '))
                          ? item.join(' ; ')
                          : `$$${item.join(' ; ')}$$`
                        : ''), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ], 8, _hoisted_11)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            class: "m-section-content question-answer",
            id: `questionAnswer_${$props.questionIndex}`
          }, null, 8, _hoisted_19)
        ])
      ])
    ]),
    _hoisted_20,
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", {
        class: "m-section-content question-title",
        id: `questionAnalysis_${$props.questionIndex}`
      }, null, 8, _hoisted_23)
    ]),
    ($setup.playVideoParam?.content_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", {
            class: "m-section-content relate-video",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.doPlayVideo && $setup.doPlayVideo(...args)))
          }, [
            ($setup.videoImg)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $setup.videoImg,
                  alt: "",
                  class: "video-img"
                }, null, 8, _hoisted_26))
              : _createCommentVNode("", true),
            _hoisted_27
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}